import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.PaymentProfileDetailView.';

  public static readonly providePaymentProfileName = `${Id.prefix}providePaymentProfileName`;
  public static readonly paymentProfileInfo = `${Id.prefix}paymentProfileInfo`;
  public static readonly paymentProfile = `${Id.prefix}paymentProfile`;
  public static readonly calculation = `${Id.prefix}calculation`;
  public static readonly valuePercent = `${Id.prefix}valuePercent`;
  public static readonly paymentProfileCalculationMargin = `${Id.prefix}paymentProfileCalculationMargin`;
  public static readonly paymentProfileCalculationMarkup = `${Id.prefix}paymentProfileCalculationMarkup`;
}

export class LangPaymentProfileDetailView {
  private constructor() {}

  public static providePaymentProfileName(): string {
    return interpolate(Id.providePaymentProfileName);
  }
  public static paymentProfileInfo(): string {
    return interpolate(Id.paymentProfileInfo);
  }
  public static paymentProfile(): string {
    return interpolate(Id.paymentProfile);
  }
  public static calculation(): string {
    return interpolate(Id.calculation);
  }
  public static valuePercent(): string {
    return interpolate(Id.valuePercent);
  }
  public static readonly paymentProfileCalculation = {
    margin: () => interpolate(Id.paymentProfileCalculationMargin),
    markup: () => interpolate(Id.paymentProfileCalculationMarkup)
  };
}

export class PaymentProfileDetailViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.providePaymentProfileName,
      "Please provide a {{glossary 'payment-profile'}} name",
      'Validation for payment profile name'
    );
    register.add(Id.paymentProfileInfo, "{{glossary 'payment-profile'}} Info", 'Caption for payment profile info');
    register.add(Id.paymentProfile, "{{glossary 'payment-profile'}}", 'Label for payment profile name');
    register.add(Id.calculation, 'Calculation', 'Label for calculation radio group');
    register.add(Id.valuePercent, 'Value (%)', 'Label for value percent');
    register.add(Id.paymentProfileCalculationMargin, 'Margin', 'Payment profile calculation: Margin');
    register.add(Id.paymentProfileCalculationMarkup, 'Markup', 'Payment profile calculation: Markup');
  }
}
